import { Image, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";

export const UserManagementEmptyState = () => {
  const i18n = useI18n();
  return (
    <Stack alignItems="center" justifyContent="center" gap={2} mixin={{ paddingBlockStart: 16 }}>
      <Image
        asset={{
          setName: "illustrations-partner-thumbnails",
          assetName: "Search",
        }}
        width={30}
      />
      <Stack alignItems="center" gap={1}>
        <Text variant="strong_1">{i18n.trans(t("flights_airline_portal_user_management_search_no_results_header"))}</Text>
        <Text variant="body_2" color="neutral_alt">
          {i18n.trans(t("flights_airline_portal_user_management_search_no_results_subheader"))}
        </Text>
      </Stack>
    </Stack>
  );
};
